import type { MouseEventHandler, ReactNode } from 'react';

export function isActionButtonDisplayed(
    label?: ReactNode,
    href?: string,
    onClick?: MouseEventHandler<HTMLButtonElement>,
): boolean {
    return !!(label && (href || onClick));
}

export function getStickyOffset(temporaryMessageHeaderHeight: number): number | undefined {
    if (!temporaryMessageHeaderHeight) {
        return undefined;
    }

    return temporaryMessageHeaderHeight;
}
